module.exports = "https://static.wmbcdn.com/uniweb/images/f62b0ea2f05daeaddea8abca477cd7f6.svg";